'use client'

import { useEffect } from 'react'

import { AlertTriangle } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface ErrorProps {
	error: Error & { digest?: string }
	reset: () => void
}

export default function Error({ error, reset }: ErrorProps) {
	useEffect(() => {
		// Log error to monitoring service
		console.error('Route error:', error)
	}, [error])

	return (
		<div className="flex min-h-[400px] flex-col items-center justify-center p-8">
			<div className="max-w-md text-center">
				<AlertTriangle className="text-destructive mx-auto h-12 w-12" />
				<h2 className="mt-4 text-2xl font-semibold">Algo salió mal</h2>
				<p className="text-muted-foreground mt-2">
					{process.env.NODE_ENV === 'development'
						? error.message
						: 'Ha ocurrido un error inesperado. Por favor, intenta de nuevo.'}
				</p>
				{error.digest && (
					<p className="text-muted-foreground mt-2 text-xs">Error ID: {error.digest}</p>
				)}
				<div className="mt-6 flex justify-center gap-4">
					<Button onClick={reset}>Intentar de nuevo</Button>
					<Button variant="outline" onClick={() => (window.location.href = '/')}>
						Volver al inicio
					</Button>
				</div>
			</div>
		</div>
	)
}
